import {InjectionToken} from '@angular/core';

export const TISA_VIEW_CATEGORY_PATH = new InjectionToken(
  'Provides path to a single category page.',
);
